import type FeatureFlagsService from 'garaje/services/feature-flags';
import type StateService from 'garaje/services/state';
import { isBillingFeatureEnabled } from 'garaje/utils/billing-features';

/**
 * True when the current scope gets the Threat intelligence surface.
 *
 * Either the `threat_dashboard` billing entitlement (paid tier, read via
 * `state.features?.features` — scope- and MPB-aware) or the
 * `emno-threat-intelligence-vr-ent-limited` Split, which stands in for ent-limited customers
 * who don't carry the entitlement yet.
 *
 * Single source of truth for the consumers that must agree: the menu items and the two routes.
 * See `helpers/threat-intel-v2-enabled.ts` for the template-side wrapper.
 */
export function hasThreatIntelV2Access(featureFlags: FeatureFlagsService, state: StateService): boolean {
  const billingEntitlement = isBillingFeatureEnabled('threat_dashboard', state);
  const entLimitedSplit = featureFlags.isEnabled('emno-threat-intelligence-vr-ent-limited');
  return billingEntitlement || entLimitedSplit;
}
